import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../packages/api-models/common/json_query';

export function trackMapButtonClick(jsonQuery: IJsonQuery, queryString: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'MAP',
    category: 'Listing',
    page: {
      pageType: 'Map',
      extra: {
        mobileWebsiteType: 'new',
      },
      // Когда мкс отображается на ЧПУ ссылке queryString можно получить только из стейта
      queryString: window.location.search || queryString,
    },
    sc: jsonQuery,
  });
}
